import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-public',
  templateUrl: './general-public.component.html',
  styleUrls: ['./general-public.component.css']
})
export class GeneralPublicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}